import { useEffect, useRef, useState } from "react";
import './ArrowsSlider.scss';
import leftArrow from './assets/left-arrow.svg';
import rightArrow from './assets/right-arrow.svg';

import { UseInterval } from "./UseInterval";
import { useNavigate } from "react-router-dom";

const SLIDE_TRANSITION = 'all 1s linear';

function SlideMedia({ slide }) {
    if (slide?.video) {
        return (
            <video
                className="arrow-slider__media"
                src={slide.video}
                poster={slide.poster || undefined}
                autoPlay
                muted
                loop
                playsInline
                preload="metadata"
            />
        );
    }
    return <img className="arrow-slider__media" src={slide?.img} alt="" />;
}

export function ArrowsSlider({ imagesToShow, images }) {

    const [slideXPos, setSlideXPos] = useState(-imagesToShow);
    const movePercent = (100 / imagesToShow).toFixed(5)
    const [swichSlides, setSwichSlides] = useState({ transform: `translateX(${slideXPos * movePercent}%)`, transition: 'all 0s linear' });
    const [activeSmalldots, setActiveSmalldots] = useState(0)
    const [tapExploreVisible, setTapExploreVisible] = useState(true);
    let [delay, setDelay] = useState(null);
    const navigate = useNavigate();
    const slidesRef = useRef(null);

    useEffect(() => {
        if (swichSlides.transition === '' && delay === null) {
            console.log('in');
            setSwichSlides({ transform: `translateX(${0}px)`, transition: 'none' });
            setSlideXPos(0)
            setTapExploreVisible(true);
        }
        else if (swichSlides.transition === '') {
            console.log('in');
            setSwichSlides({ transform: `translateX(${slideXPos * movePercent}%)`, transition: 'none' });
            setDelay(10);
            setSlideXPos(0)
            setTapExploreVisible(true);
        }
        else if (swichSlides.transition === SLIDE_TRANSITION) {
            setTapExploreVisible(false);
        }
        else if (swichSlides.transition === 'none') {
            setTapExploreVisible(true);
        }
    }, [swichSlides])

    useEffect(() => {
        setDelay(14500);
    }, [])

    console.log('imagesToShow - ', imagesToShow, ' images - ', images.img, ' movePercent - ', movePercent);

    function handleSlidesTransitionEnd(e) {
        if (e.target !== slidesRef.current) return;
        if (e.propertyName && e.propertyName !== 'transform') return;
        setTapExploreVisible(true);
    }

    function swichSlideXPosBack() {
        console.log('slideXPos - ', slideXPos);

        if (slideXPos === 0) {
            console.log('triggere 1');
            setSwichSlides({ transform: `translateX(${-images.length * movePercent}%)`, transition: 'A' })
            setSlideXPos(-images.length);
            // setActiveSmalldots(images.length - 2);
        }
        else {
            console.log('triggere 3');
            console.log(slideXPos + 1);
            setTapExploreVisible(false);
            setSwichSlides({ transform: `translateX(${(slideXPos + 1) * movePercent}%)`, transition: SLIDE_TRANSITION });
            setSlideXPos(slideXPos + 1);
            setActiveSmalldots(activeSmalldots - 1);
        }

        if (slideXPos === -1 || slideXPos === -5) {
            setActiveSmalldots(images.length - 1);

        }
    }

    function swichSlideXPosNext() {
        console.log('slideXPos - ', slideXPos);
        console.log('images.length - ', images.length);



        if (slideXPos === -(images.length + imagesToShow)) {
            console.log('triggere 1');
            setSwichSlides({ transform: `translateX(${-imagesToShow * movePercent}%)`, transition: '' })
            setSlideXPos(-imagesToShow);
            // setActiveSmalldots(1);
            // setDelay(200)

        }
        else {
            console.log('triggere 3');
            console.log(slideXPos - 1);
            setTapExploreVisible(false);
            setSwichSlides({ transform: `translateX(${(slideXPos - 1) * movePercent}%)`, transition: SLIDE_TRANSITION });
            setSlideXPos(slideXPos - 1);
            setActiveSmalldots(activeSmalldots + 1);
        }

        if (slideXPos === -(images.length) || slideXPos === 0) {
            setActiveSmalldots(0);
        }
    }

    console.log('activeSmalldots - ', activeSmalldots);

    UseInterval(() => {
        // Your custom logic here
        // setCount(count + 1);
        if (delay === 20) {
            setDelay(14500);
        }
        else if (delay === 10) {
            setDelay(20);
        }
        swichSlideXPosNext();
    }, delay);

    function indicatorPressed(pos) {
        if (pos > slideXPos + 1) {
            console.log('triggered');
            // let nextMove = -(pos - (slideXPos))
            let nextMove = -(pos - (-1))
            console.log('slideXPos - ', slideXPos);
            console.log('nextMove - ', nextMove);

            setTapExploreVisible(false);
            setSwichSlides({ transform: `translateX(${nextMove * movePercent}%)`, transition: SLIDE_TRANSITION });
            setSlideXPos(nextMove);
            // setSlideXPos(-5);

            if ((slideXPos - nextMove) === -(images.length)) {
                setActiveSmalldots(activeSmalldots + nextMove);
            }
            else {
                setActiveSmalldots(Math.abs(nextMove + 1));
            }
        }
    }

    return (
        <div className="arrow-slider">
            <div className="specific-slide-main">
                <div className='specific-slide-container'>

                    <div className="container">
                        <div className="main">

                            <div
                                className="slides"
                                ref={slidesRef}
                                style={swichSlides}
                                onTransitionEnd={handleSlidesTransitionEnd}
                            >
                                {
                                    images.filter((imgSrc, key) => {
                                        const skip = images.length - imagesToShow;
                                        if (key < skip) return;
                                        return imgSrc
                                    }).map((imgObj, key) => {
                                        return <div key={`pre-${key}`} style={{ width: `${movePercent}%` }} onClick={() => navigate(imgObj.url)}>
                                            <SlideMedia slide={imgObj} />
                                        </div>
                                    })
                                }
                                {
                                    images.map((imgObj, key) => {
                                        return <div key={`main-${key}`} style={{ width: `${movePercent}%` }} onClick={() => navigate(imgObj.url)}>
                                            <SlideMedia slide={imgObj} />
                                        </div>
                                    })
                                }
                                {
                                    images.filter((imgObj, key) => {
                                        if (key < imagesToShow) {
                                            return true;
                                        }
                                        return false;
                                    }).map((imgObj, key) => {
                                        return <div key={`post-${key}`} style={{ width: `${movePercent}%` }} onClick={() => navigate(imgObj.url)}>
                                            <SlideMedia slide={imgObj} />
                                        </div>
                                    })
                                }
                            </div>

                        </div>

                    </div>
                </div>

            </div>

            <button
                type="button"
                className={`arrow-slider__tap-explore${tapExploreVisible ? '' : ' is-hidden'}`}
                tabIndex={tapExploreVisible ? 0 : -1}
                aria-hidden={!tapExploreVisible}
                onClick={() => {
                    const slide = images[activeSmalldots] || images[0];
                    if (slide?.url) navigate(slide.url);
                }}
            >
                {(images[activeSmalldots] || images[0])?.cta || 'Tap to explore'}
            </button>

            <div className="arrows-buttons">
                {/* <button className="prev-button" onClick={swichSlideXPosBack}><img src={leftArrow} /></button> */}
                {/* <button className="next-button" onClick={swichSlideXPosNext}><img src={rightArrow} /></button> */}
            </div>

            <ul className="smalldots">
                <li className={activeSmalldots === 0 ? 'slick-active' : ''} onClick={() => indicatorPressed(0)}>
                    <button>1</button>
                </li>
                <li className={activeSmalldots === 1 ? 'slick-active' : ''} onClick={() => indicatorPressed(1)}>
                    <button>2</button>
                </li>
                <li className={activeSmalldots === 2 ? 'slick-active' : ''} onClick={() => indicatorPressed(2)}>
                    <button>3</button>
                </li>
                <li className={activeSmalldots === 3 ? 'slick-active' : ''} onClick={() => indicatorPressed(3)}>
                    <button>4</button>
                </li>
            </ul>

        </div>
    )
}
